
import { Vue, Component } from "vue-property-decorator";
import api from "@/api/index";
import {OrganizationUnitDto, ProfitReportStandardDto, ProfitType} from "../../api/appService";
const ouKey = "Abp-OrganizationUnitId";
import Cookies from "js-cookie";
import ExportTableHtml from "@/components/ExportTableHtml/index.vue";
import {ancestorWhere} from "tslint";
import ReportTable from "@/views/report/component/report-table.vue";
import ReportTip from "@/views/report/component/report-tip.vue";
export const getOu = () => Cookies.get(ouKey);
@Component({
  components: {ReportTip, ReportTable, ExportTableHtml}
})
export default class ProjectDetail extends Vue {
  detail: ProfitReportStandardDto[] = [];
  storesList: any[] = [];
  month: Number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  queryForm: any = {
    year: undefined,
    organizationUnitId: undefined,
    orgs: []
  };

  get profitType(){
    return ProfitType.PartialArea;
  }

  async created() {
    this.queryForm.year = new Date().getFullYear();
    const currentOu = (this.$store.getters['user/user'] as OrganizationUnitDto);
    if(currentOu.level === '片区'){
      this.queryForm.organizationUnitId = currentOu.id;
      await this.fetchDetail();
    } else {
      await api.organizationUnit
        .getOrganizationUnitsOfDescendant({
          orgId: currentOu.id,
        })
        .then(res => {
          this.queryForm.orgs = res.filter(s=>!s.isLeaf && s.id!==currentOu.id && s.level === '片区');
          if(this.queryForm.orgs.length>0){
            this.queryForm.organizationUnitId = this.queryForm.orgs[0].id;
          }
          this.fetchDetail();
        });
    }

  }

  async fetchDetail() {
    await api.profitReport
      .getProfitOfPartialArea({
        year: this.queryForm.year,
        organizationUnitId: this.queryForm.organizationUnitId
      })
      .then(res => {
        this.detail = res;
      });
  }

  // 搜索
  async handleSearch() {
    await this.fetchDetail();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      year: new Date().getFullYear(),
      organizationUnitId: Number(getOu())
    };
    await this.fetchDetail();
  }

  fetchStores() {
    let that = this;
    api.client.getStores().then(res => {
      this.storesList = res;
    });
  }

  back() {
    this.$router.go(-1);
  }
}
